import { render, staticRenderFns } from "./FamilySalesReport.vue?vue&type=template&id=3b24d728&scoped=true&"
import script from "./FamilySalesReport.vue?vue&type=script&lang=js&"
export * from "./FamilySalesReport.vue?vue&type=script&lang=js&"
import style0 from "./FamilySalesReport.vue?vue&type=style&index=0&id=3b24d728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b24d728",
  null
  
)

export default component.exports